module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-douwe-egberts-intro-card1.1@2x.5c1904b0.jpg";